export default __webpack_public_path__ + "static/media/8k_earth_clouds.08fcd800.jpg";